import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const liveCasinoState = {
  liveCasinoPageUI: null,
  liveCasinoGameList: null,
  gamePlay: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const liveCasinoSlice = createSlice({
  name: "liveCasino",
  initialState: liveCasinoState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    liveCasinoPageUIFetched: (state, action) => {
      state.listLoading = false;
      state.liveCasinoPageUI = action.payload.data ?? {};
    },
    liveCasinoGameListFetched: (state, action) => {
      state.listLoading = false;
      state.liveCasinoGameList = action.payload.data ?? {};
    },
    clearLiveCasinoGameList: (state, action) => {
      state.liveCasinoGameList = liveCasinoState.liveCasinoGameList;
    },
    playCompanyGame: (state, action) => {
      state.actionsLoading = false;
      state.gamePlay = action.payload.data ?? {};
    },
  },
});
